<template lang="pug">
div
  Navbar
  section.hero.is-fullheight-with-navbar.is-black.is-bold
    .hero-body
      .container
        h1.title.has-text-white Contact Us
        h2.subtitle.has-text-white Get in touch
        .columns
          .column.is-2
            .has-background-dark.rounded.highlight
              a(href="mailto:contact@fanfairmedia.com")
                .container.is-fluid
                  br
                  .columns.is-centered
                    .column.is-narrow
                      font-awesome-icon(:icon="['fas', 'envelope']", size="4x")
                  .columns.is-centered
                    .column.is-narrow
                      p.is-size-4 Email Us
                  br
          .column.is-2
            .has-background-purple.rounded.highlight
              a(href="https://www.instagram.com/fanfairmedia/")
                .container.is-fluid
                  br
                  .columns.is-centered
                    .column.is-narrow
                      font-awesome-icon(:icon="['fab', 'instagram']", size="4x")
                  .columns.is-centered
                    .column.is-narrow
                      p.is-size-4 Message Us
                  br
          .column.is-2
            .has-background-info.rounded.highlight
              a(href="https://twitter.com/messages/compose?recipient_id=1242253895201484801")
                .container.is-fluid
                  br
                  .columns.is-centered
                    .column.is-narrow
                      font-awesome-icon(:icon="['fab', 'twitter']", size="4x")
                  .columns.is-centered
                    .column.is-narrow
                      p.is-size-4 DM Us
                  br
</template>

<script>
import Navbar from "@/components/Navbar.vue";
import Hero from "@/components/Hero.vue";

export default {
  name: "ContactUs",

  components: {
    Navbar,
    Hero
  }
};
</script>

<style lang="scss" scoped>
a {
  color: white;
}

a:hover {
  color: white;
}

.rounded {
  border-radius: 10px;
}

p {
  color: white;
}

.highlight {
  -webkit-filter: brightness(100%);
}

.highlight:hover {
  -webkit-filter: brightness(70%);
  -webkit-transition: all 1s ease;
  -moz-transition: all 1s ease;
  -o-transition: all 1s ease;
  -ms-transition: all 1s ease;
  transition: all 1s ease;
  cursor: pointer;
}
</style>
